import  React from 'react';
import  ReactDOM from 'react-dom';
import Modal from './modal';
import { IData } from '../core/models/lightbox';
import {IMetrics} from '../core/models/metrics';
import {metricsEvent} from '../core/classes/api';

export default class LightboxCOH extends React.Component<IData> {
     constructor(props: IData) {
          super(props);
          this.closeModal = this.closeModal.bind(this);
          this.renderMarkup = this.renderMarkup.bind(this);
          this.metricHandler = this.metricHandler.bind(this);
     }

     public closeModal() {
          const event:IMetrics = {
               category: this.props.type,
               referer: window.location.href,
               campaign: this.props.campaign,
               action: 'dismiss modal'
          }
          metricsEvent(event);
          this.componentWillUnmount();
     }

     public metricHandler(){
          const event:IMetrics = {
               category: this.props.type,
               referer: window.location.href,
               campaign: this.props.campaign,
               action: 'cta taken'
          }
          metricsEvent(event);
     }

     public renderMarkup(html: any): any {
          return { __html: html };
     }

     componentWillUnmount() {
          const element = document.getElementById('directresponse-module') as HTMLElement;
          ReactDOM.unmountComponentAtNode(element);
     }

     public render() {
          return (
               <div>
                    <link rel="stylesheet" href={this.props.styleSheetUrl} />
                    <Modal
                         handleClose={this.closeModal}
                         background={this.props.backgroundLink}
                         class={this.props.class}>

                         <div className="main-body">
                              <p className="title" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.title)} />
                              <p className="sutTitle" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.subTitle)} />
                              <p className="body" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.body)} />
                              <br />
                              <div className="button-holder">
                                   <a
                                        onClick={this.metricHandler}
                                        href={this.props.content.footer.button.link}
                                        className={this.props.content.footer.button.color
                                             ? 'button-exec ' + this.props.content.footer.button.color
                                             : 'button-exec'}>{this.props.content.footer.button.text}</a>
                                   <a href="../"  rel="noreferrer"  onClick={this.closeModal}>No, thanks.</a>
                              </div>
                              <p className="type" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.type)} />
                              <p
                                   className="type-sub"
                                   dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.subType)} />
                         </div>
                    </Modal>
               </div>
          );
     }
}    